import UpdateEmail from "../components/configuration/email/UpdateEmail";

const UpdateEmailPage = () => {
    return(
        <UpdateEmail/>
    )
}

export default UpdateEmailPage;
